import { render, staticRenderFns } from "./SearchBarHeader.vue?vue&type=template&id=4d6f4f5c&"
import script from "./SearchBarHeader.vue?vue&type=script&lang=ts&"
export * from "./SearchBarHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBarHeader.vue?vue&type=style&index=0&id=4d6f4f5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports